// 9fbef606107a605d69c0edbcd8029e5d
import { SESSIONCONFIG_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';

export const getDefaultBopisPromotionDiscountValue = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseInt(
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.DEFAULT_BOPIS_PROMOTION_DISCOUNT_VALUE,
      10
    )
  );
};

export const getOfferTypeBasedPromotion = (state) => {
  return state && state?.Promotions?.offerTypeBasedPromotion;
};
